import { Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./breadcrumb.module.css";
const Breadcrumb = ({ customPaths = [] }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const getBreadcrumbItems = () => {
    if (customPaths.length > 0) {
      return customPaths;
    }
    const paths = pathname.split("/").filter(Boolean);
    return paths.map((path, index) => ({
      label: path.replace(/-/g, " "),
      path: "/" + paths.slice(0, index + 1).join("/"),
    }));
  };
  const breadcrumbItems = getBreadcrumbItems();
  const handleHomeClick = () => {
    navigate("/");
  };
  return (
    <div className={styles.breadcrumb}>
      <div className={styles.breadcrumbWrapper}>
        <nav className={styles.breadcrumbNav} aria-label="Breadcrumb">
          <ol className={styles.breadcrumbList}>
            <li className={styles.breadcrumbItem}>
              <span
                className={styles.homeLink}
                onClick={handleHomeClick}
                role="button"
                tabIndex={0}
              >
                Home
              </span>
            </li>
            {breadcrumbItems.map((item, index) => {
              const isLast = index === breadcrumbItems.length - 1;
              return (
                <Fragment key={index}>
                  <li className={styles.separator} aria-hidden="true">
                    /
                  </li>
                  <li className={styles.breadcrumbItem}>
                    {isLast ? (
                      <span className={styles.pathLocation}>{item.label}</span>
                    ) : (
                      <span
                        className={styles.breadcrumbLink}
                        onClick={() => navigate(item.path)}
                        role="button"
                        tabIndex={0}
                      >
                        {item.label}
                      </span>
                    )}
                  </li>
                </Fragment>
              );
            })}
          </ol>
        </nav>
      </div>
    </div>
  );
};
export default Breadcrumb;